const TAIWAN_BUSINESS_ID_WEIGHTS = [1, 2, 1, 2, 1, 2, 4, 1]

export function isValidTaiwanMobile(value: string): boolean {
  const trimmed = value.trim()

  return /^09\d{8}$/.test(trimmed)
}

export function isValidTaiwanBusinessId(value: string): boolean {
  if (!/^\d{8}$/.test(value)) {
    return false
  }

  const digits = Array.from(value, (digit) => Number(digit))
  const total = digits.reduce((sum, digit, index) => {
    const product = digit * TAIWAN_BUSINESS_ID_WEIGHTS[index]

    return sum + Math.floor(product / 10) + (product % 10)
  }, 0)

  return total % 5 === 0 || (digits[6] === 7 && (total + 1) % 5 === 0)
}
